/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import CurrencyInputWithFlag from "../CurrencyInputWithFlag";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { axiosInstance } from "../../axios/axios";
import { ApiKey } from "../../ApiKey/ApiKey";

const HomeBanner = ({
  selectedCurrency,
  setSelectedCurrency,
  convertSelectedCurrency,
  setConvertSelectedCurrency,
  amount,
  setAmount,
  convertAmount,
  setConvertAmount,
  conversionRate,
  setConvertionRate,
}) => {
  const [countryData, setCountryData] = useState([]);

  const [loading, setLoading] = useState(false);

  const getCurrentTime12Hour = () => {
    const now = new Date();
    let hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;
    hours = hours.toString().padStart(2, "0");

    return `${hours}:${minutes}  ${ampm}`;
  };

  const handleCurrencyChange = (selectedOption) => {
    setLoading(true);
    setSelectedCurrency(selectedOption);
  };
  const handleConvertCurrencyChange = (selectedOption) => {
    setLoading(true);
    setConvertSelectedCurrency(selectedOption);
  };
  const getAllCurrency = async () => {
    try {
      const response = await axiosInstance.get(`${ApiKey}/codes`);

      const formattedData = response?.data?.supported_codes.map((item) => ({
        currencyCode: item[0],
        currencyName: item[1],
      }));

      setCountryData(formattedData);
    } catch (error) {
      throw error;
    }
  };

  const handleAmount = async (amountget = 0) => {
    setAmount(amountget);
    try {
      const response = await axiosInstance.get(
        `${ApiKey}/pair/${selectedCurrency?.currencyCode}/${convertSelectedCurrency?.currencyCode}`
      );
      setConvertionRate(response?.data?.conversion_rate);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setConvertAmount((amount * conversionRate).toFixed(2));
    setLoading(false);
  }, [amount, conversionRate]);

  const reverseValues = async (convertedCurrency, currentCurrency) => {
    setLoading(true);
    setSelectedCurrency(convertedCurrency);
    setConvertSelectedCurrency(currentCurrency);
  };

  useEffect(() => {
    handleAmount(amount);
  }, [selectedCurrency, convertSelectedCurrency, amount]);

  useEffect(() => {
    getAllCurrency();
  }, []);

  return (
    <div className="bg-black md:py-12 py-6">
      <div className="container px-12 mx-auto">
        <h1 className="lg:w-6/12 w-full text-primary md:text-5xl text-2xl font-bold">
          {amount} {selectedCurrency?.currencyName} to{" "}
          {convertSelectedCurrency?.currencyName}
        </h1>
        <p className="text-xl md:text-3xl text-white py-10">
          Convert {selectedCurrency?.currencyCode} to{" "}
          {convertSelectedCurrency?.currencyCode} at the real exchange rate
        </p>
        {loading ? (
          <div className="bg-primary p-4 rounded-full w-fit bolck mx-auto">
            <img
              src="/assets/images/loading.gif"
              className="w-50"
              alt="loading"
            />
          </div>
        ) : (
          <div className="flex lg:flex-row  flex-col lg:gap-6 gap-4 lg:justify-between justify-center items-center ">
            <div>
              <p className="text-white ">Amount</p>
              <CurrencyInputWithFlag
                selectedCurrency={selectedCurrency}
                handleCurrencyChange={handleCurrencyChange}
                amount={amount}
                handleAmount={handleAmount}
                countryData={countryData}
              />
            </div>
            <button
              onClick={() =>
                reverseValues(convertSelectedCurrency, selectedCurrency)
              }
            >
              <FaArrowRightLong color="white" size={20} />
              <FaArrowLeftLong color="white" size={20} />
            </button>
            <div>
              <p className="text-white ">Converted to</p>
              <CurrencyInputWithFlag
                selectedCurrency={convertSelectedCurrency}
                handleCurrencyChange={handleConvertCurrencyChange}
                amount={convertAmount}
                handleAmount={handleAmount}
                countryData={countryData}
                readOnly={true}
              />
            </div>
          </div>
        )}

        <div className="flex lg:flex-row flex-col  justify-between items-center gap-4 pt-4">
          <div>
            <p className="text-white text-2xl">
              {amount} {selectedCurrency?.currencyCode}{" "}
              <span className="text-primary">{convertAmount} </span>{" "}
              {convertSelectedCurrency?.currencyCode}
            </p>
            <p className="text-white">
              Mid-market exchange rate at {getCurrentTime12Hour()}
            </p>
          </div>

          <div className="flex md:flex-row flex-col justify-between items-center gap-4">
            <button className="text-white border-white border-2 py-2 rounded-primary px-4">
              Track the exchange rate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
